module.exports = __webpack_public_path__ + "static/img/red.a1919df4.png";